import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Message} from "primeng/primeng";
import {Usuario} from "./Usuario";
import {Rol} from "./rol";
import {UsuarioService} from "../Services/usuario.service";


@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.css']
})
export class UsuarioComponent implements OnInit {

  msgs: Message[] = [];
  formUsuario : FormGroup;
  formRol : FormGroup;
  btnNuevoRol = true;
  btnCancelarRol = false;
  btnGuardarRol = false;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  UsuariosRegistrados:Usuario[];
  UsuarioSeleccionado:Usuario;
  tipoGuardado = '';
  panelRequeridosRol = false;
  RolesRegistrados:Rol[];


  constructor(private servicioUsuario:UsuarioService,private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesUsuario();
    this.crearControlesRol();
    this.Cancelar();
    this.listarUsuarios();
    this.listarRol();
  }

  crearControlesUsuario(){
    this.formUsuario = this.fb.group({
      name:['',Validators.required],
      email:['',Validators.required],
      password:[''],
      rol:[''],
      }
    );

  }
  crearControlesRol(){
    this.formRol = this.fb.group({
      nombre:['',Validators.required],
      }
    );

  }
  nuevoRol(){
    this.btnNuevoRol = false;
    this.btnGuardarRol = true;
    this.btnCancelarRol = true;
    this.formRol.enable();
    this.formRol.reset();
    this.panelRequeridosRol = true;
  }
  CancelarRol(){
    this.btnGuardarRol = false;
    this.btnNuevoRol = true;
    this.btnCancelarRol = false;
    this.formRol.reset();
    this.formRol.disable();
    this.panelRequeridosRol = false;
  }
  guardarNuevoRol(){
      this.loading = true;
      this.servicioUsuario.addRol(this.formRol.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarRol();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.CancelarRol();
          });
  }
  listarRol(){
    this.loading = true;
    this.servicioUsuario.getRol()
      .subscribe(
        rt => {
          this.RolesRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  nuevoUsuario(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formUsuario.enable();
    this.formUsuario.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formUsuario.reset();
    this.formUsuario.disable();
    this.panelRequeridos = false;
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoUsuario(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      console.log(this.formUsuario.value);
      this.servicioUsuario.putUsuario(this.formUsuario.value,this.UsuarioSeleccionado['usuario_id'])
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarUsuarios();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      this.servicioUsuario.addUsuario(this.formUsuario.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarUsuarios();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarUsuarios(){
    this.loading = true;
    this.servicioUsuario.getUsuario()
      .subscribe(
        rt => {
          this.UsuariosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarUsuario(item:Usuario){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formUsuario.enable();
    this.panelRequeridos = true;
    this.UsuarioSeleccionado = item;
    this.UsuarioDetalle(item);
    this.tipoGuardado = 'editar';
  }
  UsuarioDetalle(item:Usuario):void {
    this.formUsuario.patchValue({
      id:item['usuario_id'],
      name:item['usuario'].name,
      email:item['usuario'].email,
      rol:item['role_id'],

    });
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/usuario/usuario.component.ts